import React from "react";

/**
 * Mandated compliance/trust label required by PRD §13 on every AI-produced
 * output surface. Reused in three places: ExplainFindingDialog header,
 * StrategyOptionsPanel header, ValidationSuggestionDialog header.
 *
 * Contract:
 *   * The text is a compliance-adjacent trust label — do NOT edit the
 *     wording. If the PRD ever changes it, change it here in one place
 *     and every consuming component follows.
 *   * Uses a real em-dash (—, U+2014), not a hyphen. Tests assert the
 *     exact codepoint.
 *   * Emit the same `data-testid` shape every consumer uses:
 *     `explain-mandated-label-<scopeId>`, prefixed however the consumer
 *     wants — the caller supplies `testId` for uniqueness.
 */
export const AI_MANDATED_LABEL_TEXT =
  "AI-generated recommendation \u2014 requires professional review";

export function AIMandatedLabel({ testId }) {
  return (
    <div
      data-testid={testId}
      className="text-[11px] font-semibold uppercase tracking-widest text-violet-700"
    >
      {AI_MANDATED_LABEL_TEXT}
    </div>
  );
}
